function toYouTubeEmbedUrl(url: string): string {
    // If it's already an embed URL, return as-is
    if (url.includes('/embed/')) {
        return url;
    }

    try {
        const parsed = new URL(url);

        // youtu.be short URL -> https://www.youtube.com/embed/VIDEO_ID
        if (parsed.hostname === 'youtu.be') {
            const videoId = parsed.pathname.replace('/', '');
            if (videoId) {
                return `https://www.youtube.com/embed/${videoId}`;
            }
        }

        // Standard youtube.com URLs
        if (parsed.hostname.endsWith('youtube.com')) {
            // https://www.youtube.com/watch?v=VIDEO_ID
            if (parsed.pathname === '/watch') {
                const videoId = parsed.searchParams.get('v');
                if (videoId) {
                    return `https://www.youtube.com/embed/${videoId}`;
                }
            }
        }
    } catch {
        // Fall through to returning original URL
    }

    // Fallback: use the original URL if we can't parse/convert
    return url;
}

export function YouTubeCard({id, url}: {id: string, url?: string}){
    if(!url){
        return (
            <div className="relative w-full bg-gray-200 aspect-[4/3]">
                <div className='flex items-center justify-center w-full h-full bg-gray-300 text-gray-500'>
                    No video available
                </div>
            </div>
        )
    }

    const embedUrl = toYouTubeEmbedUrl(url);

    return (
        <div className="relative w-full bg-gray-200 aspect-[4/3]">
            <div className='flex items-center justify-center w-full h-full bg-gray-300 text-gray-500'>
                <iframe
                    className="w-full h-full"
                    src={embedUrl}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                ></iframe>
            </div>
        </div>
    )
}